import { capitalize } from "client/utils/capitalize";
import { convertFromPixels } from "client/utils/pixels/convertFromPixels";
import { translateFunc } from "client/utils/translateFunc";
import { truncateImageTitle } from "client/utils/truncateImageTitle";
import { Loader } from "components/common/Icons/Loader/Loader";
import { RightIcon } from "components/common/Icons/RightIcon";
import { ToolTip } from "components/common/ToolTip/ToolTip";
import { usePreview } from "./usePreview";

export const MAX_RESIZE_SIZE_IN_PX = 15000;

export const Preview = () => {
    const { image, unit, dimensionsValid, isLoading, src, initialImageRef, downloaded } = usePreview();

    return (
        <div className="mx-4 h-full flex flex-col">
            <div className="flex flex-col gap-4 md:flex-row justify-start p-4 bg-white dark:bg-darkSurface-200 border-b border-irGray-400 xl:text-xl flex-grow-0 flex-shrink-0 text-black dark:text-white dark:border dark:border-darkSurface-400">
                <ToolTip
                    text={image.title}
                    position={{
                        y: "up",
                    }}
                >
                    <div data-testid={`preview-image-title`}>{truncateImageTitle(image.title, 35)}</div>
                </ToolTip>
                <div className="md:ml-auto flex items-center gap-2">
                    <ToolTip
                        text={capitalize(translateFunc(`original-size-in-pixels`))}
                        position={{
                            y: "up",
                        }}
                    >
                        <div
                            className="py-1 px-2 rounded-lg bg-[#abb8c3] dark:bg-darkSurface-100"
                            data-testid={`original-dimensions`}
                        >
                            {`${Math.floor(convertFromPixels(image.original.width, unit))} X ${Math.floor(
                                convertFromPixels(image.original.height, unit),
                            )}`}
                        </div>
                    </ToolTip>
                    <div>
                        <RightIcon fill="black" />
                    </div>
                    <ToolTip
                        text={
                            dimensionsValid
                                ? capitalize(translateFunc("after-resize-size-in-pixels"))
                                : `${translateFunc("maximum-dimension-tooltip-text", {
                                      dimension: Math.round(convertFromPixels(MAX_RESIZE_SIZE_IN_PX, unit)),
                                  })}`
                        }
                    >
                        <div
                            className={`cursor-pointer py-1 px-2 rounded-lg text-white ${
                                dimensionsValid ? "bg-[#7bdcb5] dark:bg-darkPrimary-100" : "bg-[#DB1436]"
                            }`}
                            data-testid={`output-dimensions`}
                        >
                            {`${Number(Math.floor(image.preview.width))} X ${Number(Math.floor(image.preview.height))}`}
                        </div>
                    </ToolTip>
                </div>
            </div>
            <div className="relative flex-grow w-full h-full flex items-start xl:items-center justify-center">
                <div className="absolute inset-0 overflow-hidden lg:flex items-center justify-center py-4">
                    <img
                        ref={initialImageRef}
                        src={src}
                        key={src}
                        className={`w-auto max-h-full mx-auto lg:mx-0 ${isLoading ? "hidden" : ""}`}
                        data-testid={`preview-image`}
                    />
                </div>
                {isLoading && (
                    <div className="flex flex-col gap-4 items-center" data-testid={`preview-loader`}>
                        <Loader className="stroke-[var(--dark-gray)]" height={35} width={35} />
                        <div className="font-semibold light:text-black dark:text-white">{`${downloaded} ${capitalize(
                            translateFunc("downloaded"),
                        )}`}</div>
                    </div>
                )}
            </div>
        </div>
    );
};
